import { render } from "./matBox.vue?vue&type=template&id=717b0000&scoped=true"
import script from "./matBox.vue?vue&type=script&lang=js"
export * from "./matBox.vue?vue&type=script&lang=js"

import "./matBox.vue?vue&type=style&index=0&id=717b0000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717b0000"]])

export default __exports__